var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M1.85 10.095V9.1H.498c-.273 0-.497.224-.497.497v6.957c0 .274.224.497.497.497H1.85v-6.957zM22.449 16.058v.994h1.354c.273 0 .497-.224.497-.497V9.598c0-.274-.224-.497-.497-.497H22.45v6.957z",
    transform: "translate(.542 .672)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M5.33 9.101h-.497v-.497c0-.547-.448-.993-.994-.993h-.994c-.547 0-.994.446-.994.993v8.945c0 .547.447.994.994.994h.994c.546 0 .994-.447.994-.994v-.497h14.634v.497c0 .547.447.994.994.994h.994c.547 0 .994-.447.994-.994V8.604c0-.547-.447-.993-.994-.993h-.994c-.547 0-.994.446-.994.993v.497H5.33zM17.78 0H6.52c-.443 0-.804.25-.804.559v.282c0 .2.155.386.405.486l5.63 2.24c.247.098.551.098.798 0l5.629-2.24c.251-.1.405-.285.406-.486V.56c0-.31-.36-.56-.804-.56z",
    transform: "translate(.542 .672)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M15.132 5.548h.993V3.561c0-.274-.223-.498-.496-.498H8.672c-.274 0-.497.224-.497.498v1.987h6.957z",
    transform: "translate(.542 .672)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M12.15 20.605c-3.556 0-6.466-2.909-6.466-6.465V7.304c0-.966.79-1.756 1.757-1.756h9.418c.967 0 1.757.79 1.757 1.756v6.836c0 3.556-2.91 6.465-6.466 6.465",
    transform: "translate(.542 .672)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.79cf094ee089c6eded6731b2a3a17559.svg";
export { ForwardRef as ReactComponent };